import { render, staticRenderFns } from "./VueTabs.vue?vue&type=template&id=3ccafb4a&"
import script from "./VueTabs.vue?vue&type=script&lang=js&"
export * from "./VueTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ccafb4a')) {
      api.createRecord('3ccafb4a', component.options)
    } else {
      api.reload('3ccafb4a', component.options)
    }
    module.hot.accept("./VueTabs.vue?vue&type=template&id=3ccafb4a&", function () {
      api.rerender('3ccafb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/components/VueTabs.vue"
export default component.exports